import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './style.scss'
import parse from 'html-react-parser'
import TeamItemModal from '../TeamItemModal'

const TeamArchive = props => {
  const { team, teamUnique } = props
  const [selectedMemberIndex, setSelectedMemberIndex] = useState(0)

  const showModal = index => {
    setSelectedMemberIndex(index)
  }

  return (
    <div className="container">
      <div className="row">
        {team &&
          team?.map((member, idx) => {
            const { item } = member
            return (
              <div
                key={idx}
                className="col-lg-4 col-sm-6 mb-3 d-flex"
                data-bs-toggle="modal"
                data-bs-target={`#${teamUnique}`}
                onClick={() => showModal(idx)}
              >
                {item && parse(item)}
              </div>
            )
          })}
        {selectedMemberIndex !== null && (
          <TeamItemModal
            team={team}
            selectedMemberIndex={selectedMemberIndex}
            index={selectedMemberIndex}
            modalId={teamUnique}
          />
        )}
      </div>
    </div>
  )
}

TeamArchive.propTypes = {
  isMobile: PropTypes.bool,
  team: PropTypes.array,
  teamUnique: PropTypes.string,
}

export default TeamArchive
